import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import Seo from "./Seo";
import { FAQS } from "../data/site";

export default function FAQ({ headline = "Common questions about Austin concrete & landscape work" }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section data-testid="faq-section" className="bg-stone-50 py-20 md:py-28 border-t border-stone-200">
      <Seo jsonLd={jsonLd} />
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-600">FAQ</div>
        <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tighter text-stone-900 leading-[1.02]">
          {headline}
        </h2>

        <div className="mt-12 bg-white border border-stone-200">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-stone-200 last:border-b-0">
                <AccordionTrigger
                  className="px-6 py-5 text-left font-display text-lg font-bold text-stone-900 hover:no-underline"
                  data-testid={`faq-question-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-stone-600 text-base leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
